// extracted by mini-css-extract-plugin
export default {"main":"ProductsPage_main__zN-WF","root":"ProductsPage_root__S-A3Y"};